export type SlashCommandItem = {
  id: string;
  label: string;
  hint: string;
};

export const SLASH_COMMANDS: SlashCommandItem[] = [
  {
    id: "sign-off",
    label: "Sign-off",
    hint: "Request approval — then @ one person",
  },
  {
    id: "update-playbook",
    label: "Update playbook",
    hint: "Add a clause to the playbook — then @ one person",
  },
];

export function filterSlashCommands(query: string): SlashCommandItem[] {
  const q = query.trim().toLowerCase().replace(/^\//, "");
  if (!q) {
    return SLASH_COMMANDS;
  }
  return SLASH_COMMANDS.filter(
    (cmd) =>
      cmd.id.includes(q) ||
      cmd.label.toLowerCase().includes(q) ||
      cmd.id.replace("-", "").includes(q.replace(/\s/g, ""))
  );
}
